let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dtoNN")).then(() => parcelRequire('53J27'));